const FaqCardList = (props) => {
  return (
    <li className="faq-card">
      <details name="faq" open>
        <summary className="boldTitle box-shadow">{props.faq}</summary>
        <div className="font-inter-regular">{props.children}</div>
      </details>
    </li>
  );
};

export default FaqCardList;
